import type { ReactNode } from 'react';
import { P, Col, Stack } from '@workramp/ui';
import { Description, MediaObjectRow, ContentCol } from './MediaObject.styles';

export interface MediaObjectProps {
  media?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  gap?: number;
}

export function MediaObject({ media, title, description, gap = 3 }: MediaObjectProps) {
  return (
    <MediaObjectRow align="center" gapX={gap}>
      {media && <Col xs="auto">{media}</Col>}
      <ContentCol>
        <Stack size={1}>
          {typeof title === 'string' ? <P size={1}>{title}</P> : title}
          {description && <Description size={1}>{description}</Description>}
        </Stack>
      </ContentCol>
    </MediaObjectRow>
  );
}
